import React, { Component } from 'react';
import { BrowserRouter, Router, Route, Switch } from 'react-router-dom';
import { history, PrivateRoute, CommonHelper } from '../src/_helpers';
import ReduxToastr from 'react-redux-toastr';
import '@pearson-components/elements-sdk/build/css/elements.css';
import './App.css';
import asyncComponent from './AsyncComponent';
import TermsOfUse from './components/footer/termsOfUse';
import PrivacyPolicy from './components/footer/privacyPolicy';
import ChangePassword from './containers/change-password/change-password';
import instruction from './containers/instruction/instruction';
import NetworkError from './components/error-pages/network-error';
import LaunchLti from './components/lti/launch-lti';
import configJson from './_helpers/config.json';
const basePath = configJson["CommonConstants"]["Base_path"]
const Home = asyncComponent(() =>
  import('./containers/home/Home').then(module => module.default)
)

const PearsonLogin = asyncComponent(() =>
  import('./containers/login/Login').then(module => module.default)
)

export default class App extends Component {
  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    return (
      <div className="App">
        <BrowserRouter>
          <div className="main_view">
            <Router history={history}>
              <Switch>
                <Route path={basePath + "/termsOfUse"} component={TermsOfUse} />
                <Route path={basePath + "/privacyPolicy"} component={PrivacyPolicy} />
                <Route exact path={basePath + "/login"} name="Login Page" component={PearsonLogin} />
                <Route exact path={basePath + "/launch-lti"} name="Lti Page" component={LaunchLti} />
                <Route exact path={basePath + "/instruction"} name="Instruction Page" component={instruction} />
                <Route exact path={basePath + "/network-error"} name="Login Page" component={NetworkError} />
                {(user !== undefined && user !== null)
                  ? CommonHelper.hasRole(user, ['Super Admin', 'Admin']) && <Route path={basePath + "/changepassword"} name="ChangePassword" component={ChangePassword} />
                  : null
                }
                <PrivateRoute path={basePath + "/"} name="Home" component={Home} />
              </Switch>
            </Router>
          </div>
        </BrowserRouter>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/App.js